import React, { Component } from "react";

class FormGroupDropdown extends Component {
  onSelectChange(value){
    if(value === ("Select " + this.props.label)) {
      value = ""
    }
    this.props.onChange(this.props.name, value);
  }

  render() {
    const { label, options, width, value, error } = this.props;

    return (
      <div className={"form-group col-md-" + width}>
        <span className="form-label font-weight-bolder">{label}</span>
        <select
          className={"custom-select" + (value === "" ? " text-muted" : "") + (error ? " is-invalid" : "")}
          onChange={ (event) => this.onSelectChange(event.target.value) }
          value={value}
        >
          <option>Select {label}</option>
          {
            options.map((option, index) => {
              return <option key={index}>{option}</option>
            })
          }
        </select>
      </div>
    )
  }
}

export default FormGroupDropdown;



// WEBPACK FOOTER //
// ./src/views/components/formGroupDropdown.js